import { Component, ChangeDetectionStrategy } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { getTitle } from '../../util/accessibility'
@Component({
  selector: 'app-salesforce-auth',
  standalone: true,
  imports: [],
  templateUrl: './salesforce-auth.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './salesforce-auth.component.scss',
})
export class SalesforceAuthComponent {
  constructor(private titleService: Title) {
    this.titleService.setTitle(getTitle('Salesforce認証'))
  }
}
